module.exports = __webpack_public_path__ + "static/media/Stellar Neo Single Headboard - 120 cm_Cream.2eee5deb.png";